<template>
  <div class="payment-info-wrap">
    <v-card class="light-card" style="height: 455px;">
      <v-toolbar color="primary" id="toolbar">
        <v-card-title class="top-title">Payment Information</v-card-title>
        <v-btn
          class="primary-btn white--text"
          dark
          @click="openDialogPayment"
        >Change Payment Method
        </v-btn>
      </v-toolbar>
      <div class="card-body" v-if="paymentInformation && !isCanceled">
        <v-card-text><strong>Country - </strong> {{paymentInformation.card.country}}</v-card-text>
        <v-card-text>
          <strong>Card details: </strong>
          {{ paymentInformation.card.brand }}
          ending with {{paymentInformation.card.last4 }}
        </v-card-text>
        <v-card-text v-if="nextBillingDate"><strong>Upcoming invoice: </strong>Your card will be
          charged on {{ nextBillingDate }} for <strong>${{ this.upcomingInvoice && (this.upcomingInvoice.amount_due / 100).toFixed(0)  }}</strong></v-card-text>
        <v-card-text>
          <v-btn @click="handleSubscriptionCancel" color="error">Cancel Subscription</v-btn>
        </v-card-text>
      </div>
      <payment-form
        v-if="updatePaymentDialog"
        :show="updatePaymentDialog"
        :paymentInfoNew="paymentInformation"
        @closeDialog="closeDialog"
      />
    </v-card>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import PaymentForm from './PaymentForm'
import stripeChargeMixin from '../../mixins/stripeChargeMixin'

export default {
  name: 'payment-info',
  mixins: [stripeChargeMixin],
  components: {
    PaymentForm
  },
  props: ['upcomingInvoice', 'paymentInformation'],
  data () {
    return {
      updatePaymentDialog: false
    }
  },
  computed: {
    ...mapGetters(['currentOrganization']),
    nextBillingDate () {
      try {
        const billingEpoch = this.upcomingInvoice.next_payment_attempt
        const d = new Date(billingEpoch * 1000)
        const dateTimeFormat = new Intl.DateTimeFormat('en', { year: 'numeric', month: 'short', day: '2-digit' })
        const [{ value: month }, , { value: day }, , { value: year }] = dateTimeFormat.formatToParts(d)

        return `${month} ${day}, ${year}`
      } catch (err) {
        return ''
      }
    },
    isCanceled () {
      return this.paymentInformation?.is_canceled
    }
  },
  methods: {
    openDialogPayment () {
      this.updatePaymentDialog = true
    },
    handleSubscriptionCancel () {
      this.$store.dispatch('cancelSubscription', this.currentOrganization.entity_id).then(() => {
        this.$store.dispatch('fetchPaymentData', this.currentOrganization.entity_id)
      })
    },
    closeDialog () {
      this.updatePaymentDialog = false
    }
  }
}
</script>
<style scoped lang="scss">
  ::v-deep {
    .v-toolbar__content {
      justify-content: space-between;
    }
  }
  .card-body {
    padding: 16px;
    color: #000;
  }
  .padding-top-to-bottom {
    > div {
      padding-top: 0;
      padding-bottom: 0;
    }
  }
</style>
